import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';
import logo from '../images/logo.svg';
import './ThankYouPage.css';

function ThankYouPage() {
  const { t } = useTranslation();

  return (
    <section className="thank-you content-panel" style={{ minHeight: '80vh' }}> 
      <div className="thank-you-logo-container">
        <img src={logo} alt={t('sylentsLogoAlt')} className="thank-you-logo" />
      </div>
      <h2 className="panel-title" style={{ color: '#17a4b0' }}>{t('thankYouTitle', 'Thank You!')}</h2> 
      
      <div className="content" style={{ textAlign: 'center' }}>
        <div style={{ margin: '2rem 0' }}>
          <CheckCircle size={64} style={{ color: '#17a4b0', marginBottom: '1rem' }} />
          <h3 style={{ color: '#17a4b0', marginBottom: '1rem' }}>{t('thankYouSubtitle', 'Your registration was successful!')}</h3>
          <p style={{ lineHeight: '1.6', marginBottom: '2rem' }}>
            {t('thankYouMessage', 'Thank you for your interest in Sylents. We have sent you a confirmation email. Please check your inbox and confirm your email address to complete the registration process.')}
          </p>
          <Link to="/" className="cta-button" style={{ display: 'inline-block' }}>
            {t('thankYouBackToHome', 'Back to Home')}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ThankYouPage; 